export default "__VITE_ASSET__728dc4ce__"